import {MessageCodes} from "../MessageCodes";
import {useAppContext} from "../../../context/AppContext";
import ResultView from "../../../components/ResultView";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import HecRasHelper from "../../../helpers/HecRasHelper";

function fmtNumber(value, digits = 2) {
    if (value === null || value === undefined || Number.isNaN(value)) return '-'
    const n = Number(value)
    if (!Number.isFinite(n)) return '-'
    return n.toLocaleString(undefined, {minimumFractionDigits: digits, maximumFractionDigits: digits})
}

const cell = (v) => (v === null || v === undefined ? '' : v)

function StatRow({label, value}) {
    return (
        <ResultRow>
            <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>{label}</ResultHeaderCell>
            <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>{value}</ResultBodyCell>
        </ResultRow>
    )
}

// The Samuel's Equation Index debug table (per-XS spacing index breakdown).
function DebugTable({rows}) {
    if (!rows || rows.length === 0) return null
    return (
        <>
            <EmptyLine/>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(10)}}>River Sta</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(8)}}>Profile</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(13)}}>Length Ch (ft)</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>Invert Slope</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(13)}}>Hydr Depth (ft)</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(13)}}>Top Width (ft)</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(16)}}>Channel DS RL (ft)</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>L/W</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>L²/W</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>Samuel's Eqn</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>L²/Samuel</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(16)}}>Length Chnl_qualified</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {rows.map((r, idx) => (
                        <ResultRow key={idx}>
                            <ResultBodyCell style={{textAlign: 'start'}}>{cell(r.cross_section)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'start'}}>{cell(r.profile)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.length_ch)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.slope)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.hydr_depth)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.top_width)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.channel_ds_rs)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.L_over_W)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.L2_over_W)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.samuel_length)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.L2_over_SL)}</ResultBodyCell>
                            <ResultBodyCell style={{textAlign: 'end'}}>{cell(r.L_qualified)}</ResultBodyCell>
                        </ResultRow>
                    ))}
                </ResultBody>
            </ResultTable>
        </>
    )
}

export function OV3({message_key}) {
    const {getSelectedHistory} = useAppContext()
    const indices = getSelectedHistory()?.calculation_tolerances?.crossSectionSpacingIndices

    if (!indices) return null

    return (
        <>
            <ResultView error_id={MessageCodes.Internal.OV03.error_id} message_key={message_key}>
                <ResultText>
                    The geometry statistics of the plan are calculated as follows.
                </ResultText>
                <EmptyLine/>
                <ResultTable>
                    <ResultBody>
                        <StatRow label={'Median Top Width (ft)'} value={fmtNumber(indices.median_top_width, 0)}/>
                        <StatRow label={'Median Reach Length (ft)'} value={fmtNumber(indices.median_reach_length, 0)}/>
                        <StatRow label={'Reach Slope (%)'} value={fmtNumber(indices.reach_slope_pct, 1)}/>
                        <StatRow label={'Top Width Ratio Index'} value={fmtNumber(indices.top_width_ratio_index, 1)}/>
                        <StatRow label={"Samuel's Equation Index"} value={fmtNumber(indices.samuel_equation_index, 1)}/>
                    </ResultBody>
                </ResultTable>
            </ResultView>

            <ResultView error_id={MessageCodes.Internal.OV03B.error_id} message_key={message_key}>
                <ResultText>
                    Samuel's Equation Index of the plan is calculated as follows.
                </ResultText>
                <DebugTable rows={indices.rows}/>
            </ResultView>
        </>
    )
}
